/* Presentation only. Product truth and persisted RFQ semantics remain in the original modules. */
import {loadState} from './b2b-rfq-store.js';
import {revalidateCatalogItems} from './vm-catalog-identity.js';
let countVersion=0;
const count = async () => {
  const version=++countVersion;
  const registry = JSON.parse(document.querySelector('[data-tr-registry]')?.textContent || '[]');
  const allowed = new Set(registry.map(p => String(p.id)));
  const workbench = document.querySelector('vemiloa-rfq-workbench');
  const state = workbench?.directRequest ? loadState().state : (workbench?.state || loadState().state);
  const checked = await revalidateCatalogItems(state.items);
  if(version!==countVersion)return;
  const items = checked.items.filter(item => allowed.has(String(item.product_id).split('/').pop()) || (item.variant_id && checked.products[String(item.product_id)]));
  document.querySelectorAll('[data-vp-rfq-count]').forEach(el => { el.textContent = String(items.length); });
};
count();
document.addEventListener('vemiloa:analytics', count);
window.addEventListener('storage', count);
document.addEventListener('change', () => queueMicrotask(count));
document.addEventListener('click', () => queueMicrotask(count));
const search = document.querySelector('.vp-search');
document.addEventListener('click', event => { if (search && !search.contains(event.target)) search.classList.remove('vp-search-active'); });
search?.addEventListener('focusin', () => search.classList.add('vp-search-active'));
search?.addEventListener('input', () => search.classList.add('vp-search-active'));
document.addEventListener('keydown', event => { if (event.key === 'Escape') search?.classList.remove('vp-search-active'); });
